<app-header></app-header>
<router-outlet></router-outlet>
<app-preloader [showLoader]="isShowPreloader"></app-preloader>